import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=dbd9557a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=dbd9557a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd9557a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbd9557a')) {
      api.createRecord('dbd9557a', component.options)
    } else {
      api.reload('dbd9557a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=dbd9557a&scoped=true&", function () {
      api.rerender('dbd9557a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QYecxdWde148/JS/teamMember.vue"
export default component.exports